import { createSlice } from "@reduxjs/toolkit";
import { getAllWheels, getOneWheel , getMyRewards , getSpinStatus} from "./thunk";

const initialState = {
  wheels: [],
  spinStatus: null,
  myRewards: [],
  oneWheel: null,
  loading: false,
  error: null,
};

const wheelSlice = createSlice({
  name: "wheelSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // ✅ GET ALL WHEELS
    builder
      .addCase(getAllWheels.pending, (state) => {
        state.loading = true;
        state.wheels = [];
        state.error = null;
      })
      .addCase(getAllWheels.fulfilled, (state, action) => {
        state.loading = false;
        state.wheels = action.payload;
      })
      .addCase(getAllWheels.rejected, (state, action) => {
        state.loading = false;
        state.wheels = [];
        state.error = action.error.message;
      });
    builder
      .addCase(getSpinStatus.pending, (state) => {
        state.loading = true;
        state.spinStatus = null;
        state.error = null;
      })
      .addCase(getSpinStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.spinStatus = action.payload;
      })
      .addCase(getSpinStatus.rejected, (state, action) => {
        state.loading = false;
        state.spinStatus = null;
        state.error = action.error.message;
      });
    builder
      .addCase(getMyRewards.pending, (state) => {
        state.loading = true;
        state.myRewards = [];
        state.error = null;
      })
      .addCase(getMyRewards.fulfilled, (state, action) => {
        state.loading = false;
        state.myRewards = action.payload;
      })
      .addCase(getMyRewards.rejected, (state, action) => {
        state.loading = false;
        state.myRewards = [];
        state.error = action.error.message;
      });

    // ✅ GET ONE WHEEL
    builder
      .addCase(getOneWheel.pending, (state) => {
        state.loading = true;
        state.oneWheel = null;
        state.error = null;
      })
      .addCase(getOneWheel.fulfilled, (state, action) => {
        state.loading = false;
        state.oneWheel = action.payload;
      })
      .addCase(getOneWheel.rejected, (state, action) => {
        state.loading = false;
        state.oneWheel = null;
        state.error = action.error.message;
      });
  },
});

export default wheelSlice.reducer;
